import React, { ReactNode } from 'react';
import { useBreakpoint } from 'hooks';
import { LayoutContext } from 'contexts';
import Button from '../Button';
import Icon from '../Icon';
import { StyledHeaderItem, StyledTitle } from './StyledComponents';
import AccountLinker from './AccountLinker';

type MobileBarProps = {
  setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  mobileMenuOpen: boolean;
  $height: number;
  hideMobileMenu?: boolean;
  showingsFeatureOn?: boolean;
  hasLinkAccountFeature?: boolean;
};

const MobileBar: React.FC<MobileBarProps> = ({
  setMobileMenuOpen,
  mobileMenuOpen,
  $height,
  hideMobileMenu,
  showingsFeatureOn,
  hasLinkAccountFeature,
}) => {
  const { setSiderCollapsed, siderCollapsed, appTitle } =
    React.useContext(LayoutContext);
  const { sm } = useBreakpoint();

  return (
    <StyledHeaderItem
      $isMobile
      $height={$height + Number(showingsFeatureOn && 2)}
      $hasShowingsMadeEasyFeature={showingsFeatureOn}
    >
      <div>
        <Button
          type="text"
          shape="circle"
          size="large"
          className="mobile-button"
          onClick={() => setSiderCollapsed((collapsed: boolean) => !collapsed)}
          icon={
            <Icon
              type="barsMenu"
              width={25}
              color={showingsFeatureOn ? 'white' : undefined}
            />
          }
        />
      </div>
      {hasLinkAccountFeature ? (
        <AccountLinker />
      ) : (
        <StyledTitle
          level={1}
          $hide={!sm && !siderCollapsed}
          $hasShowingsMadeEasyFeature={showingsFeatureOn}
        >
          {appTitle}
        </StyledTitle>
      )}
      {!hideMobileMenu && (
        <div>
          <Button
            type="text"
            shape="circle"
            size="large"
            className="mobile-button"
            onClick={() => setMobileMenuOpen((open: boolean) => !open)}
            icon={
              <Icon
                type={mobileMenuOpen ? 'x' : 'blocksMenu'}
                width={20}
                color={showingsFeatureOn ? 'white' : undefined}
              />
            }
          />
        </div>
      )}
    </StyledHeaderItem>
  );
};

export default MobileBar;
